class ToolBoxCtrl {
  constructor($scope, $timeout, FlashService, AuthService, EventService, TemplateService, TemplateValidationService, SchemaService, TBService) {
    'ngInject';
    Object.assign(this, { $scope, $timeout });
    this.fs = FlashService;
    this.ts = TemplateService;
    this.tv = TemplateValidationService;
    this.es = EventService;
    this.as = AuthService;
    this.ss = SchemaService;
    this.tbs = TBService;

    this.reference = {};
    this.missingRequired = [];
    this.hasMissingRequired = false;
    this.activeReportField = {};
    this.loadingRef = '';
    this.fileUploadConfig = {};
    this.defaultReportFields = true;
  } 
  
  async $onInit() {

    [this.PROVIDER, this.td] = await Promise.all([
      this.as.getProviderSettings(),
      this.ts.getTemplateData()
    ]); 

    const refCount = this.ts.references.length;
    if (refCount) {
      this.selectReference(this.ts.references[refCount - 1]);
    }

    this.subscribeEvents();
  }

  subscribeEvents() {
    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_VALIDATED, 
      (results) => { 
        this.$timeout(() => this.updateMissingRequired(results.REQUIRED_FIELDS.items));
      }, 'TEMPLATE_VALIDATED_TOOLBOX');

    this.es.subscribeEvent(
      this.es.actions.REFERENCE_REMOVE_BEGIN, 
      (data) => this.$timeout(_ => this.removeTable(data.reference)),
      'REFERENCE_REMOVE_BEGIN_TOOLBOX');

    this.es.subscribeEvent(
      this.es.actions.REPORT_SELECTED, 
      (data) => { 
        this.$timeout(() => { 
          if (!data.token || data.deactivate ||
            ( this.activeReportField.referenceId == data.token.referenceId && 
              this.activeReportField.fieldId == data.token.fieldId )) {
            if (data.deactivate) {
              this.activeReportField = {};
              //$(".tool-box").scrollTop(0);
            }
            return;
          }
          this.activeReportField = null;
          if (data.token) {
            this.activeReportField = { 
              fieldId: data.token.fieldId, 
              referenceId: this.reference.id, 
              tokenId: data.token.id,
              reportFields: data.token.control.reportTableSchema?.fields || []
            };
            this.$timeout(() => {
              const $box = $(".tool-box");
              const top = $(`#field${this.activeReportField.fieldId}`).offset().top - $box.offset().top + $box.scrollTop();
              $box.scrollTop(top);
            });
          }
        });
      }, 'REPORT_SELECTED_TOOLBOX');
    
    this.ts.subscribeUpdate(options => {
      this.ts.updateTemplateData(this.td, options);
      if (this.reference?.id && (!options.keys?.length || options.keys.includes('references'))) {
        if (!options.newValue.template.references.find(r => r.id === this.reference.id)) {
          this.reference = {};
        }
        this.updateFileUploadConfig();
      }
    }, 'TEMPLATE_DATA_UPDATED_TOOLBOX');

    this.es.subscribeEvent(this.es.actions.REFERENCE_SELECT_BEGIN, (data) => {
      const reference = this.ts.references.find(r => r.id == data.referenceId);
      this.selectReference(reference);
    }, 'REFERENCE_SELECT_DONE_TOOLBOX');
  }

  updateMissingRequired(items) {
    this.missingRequired = items.reduce((acc, i) => {
      acc[i.data.referenceId] = acc[i.data.referenceId] || [];
      acc[i.data.referenceId].push(i.data.fieldId);
      return acc;
    }, {});
    this.hasMissingRequired = Object.keys(this.missingRequired).length;
  }


  get fields() {
    const {tableId} = this.reference;
    return this.ss.schemas[tableId]?.fields || [];
  }

  selectReference(reference) {
    this.reference = reference;
    this.selectedReferenceId = reference.id;
    this.updateFileUploadConfig();
    
    this.es.dispatchEvent(
      this.es.actions.REFERENCE_SELECT_DONE, 
      reference.id);
  }

  updateFileUploadConfig() {
    this.fileUploadConfig = this.tbs.getRefUploadFieldConfig(this.ts.template, this.reference, this.PROVIDER, true);
  }

  hasReference() {
    return !!Object.keys(this.reference).length;
  }

  hasUnsavedChanges() {
    return this.td && this.ts.templateHasChanges(this.td?.template);
  }

  loading() {
    return this.hasReference() && !this.fields.length;
  }

  hasSchemas() {
    return !!Object.keys(this.ss.schemas).length;
  }

  filterFields() {
    const { reference } = this;
    return (field) => {
      return !!field.id
        && !this.usedFileField(field, reference, true);
    };
  }

  usedFileField(field, ref) {
    if (field.fieldType == 'attachment' && this.PROVIDER.allowMultipleAttachments) {
      return false;
    }

    return field.isFile && !!this.td.template.tokens.find(t => {
      const { fieldId, referenceId } = t;
      const isUsedFile = this.sameIds(fieldId, field.id)
        && this.sameIds(referenceId, ref.id);
      return isUsedFile && t.format !== 'image';
    });
  }

  sameIds(fid1, fid2) {
    return `${fid1}` === `${fid2}`;
  }

  configTargetTable(reference) {
    this.es.dispatchEvent(
      this.es.actions.CONFIG_TARGET_TABLE, 
      reference.id );
  }

  openDefaultLinkUploadConfig() {
    this.es.dispatchEvent(this.es.actions.OPEN_DEFAULT_LINK_UPLOAD_CONFIG, {
      referenceId: this.reference?.id || null,
    });
  }

  removeTable(ref) {
    if (this.reference.id === ref.id) this.selectReference({});
  
    const relatedTokens = this.td.template.tokens.filter(token => token.referenceId === ref.id);
    const numToRmv = relatedTokens.length;
    const answer = numToRmv
      ? confirm(`Removing this table will also remove ${numToRmv} related field(s) from this form.\nContinue?`)
      : true;

    if (answer) {
      this.selectReference({});
      this.es.dispatchEvent(this.es.actions.TOKENS_DESELECTED, null);

      const removeTokens = this.ts.tokens.filter(t => t.referenceId == ref.id);
      removeTokens.forEach(t => this.ts.removeToken(t.id));
      this.ts.removeReference(ref.id);

      this.ts.notifyUpdate(["tokens", "references", "relations", "behaviors", "conditions"], this.td);
      this.es.dispatchEvent(this.es.actions.REFERENCE_REMOVE_DONE, { id: ref.id });

      this.fs.success(`Table '${ref.name}' ${numToRmv ? `and ${numToRmv} related field${numToRmv ? 's' : ''}` : ''} removed.`);
    }
  }

  updateTemplateReferenceData() {
    this.ts.notifyUpdate(["references"], this.td);
  }

  fieldMissingRequired(field) {
    return (this.missingRequired[this.reference.id] || []).includes(String(field.id));
  }

  insertField(field) {
    if (this.activeReportField.referenceId != this.reference.id || this.activeReportField.fieldId != field.id) {
      this.es.dispatchEvent(this.es.actions.FIELD_INSERT, { field, reference: this.reference });
    }
  }

  insertReportField(reportField) {
    this.es.dispatchEvent(this.es.actions.FIELD_INSERT, { field: reportField, reportField: this.activeReportField, reference: this.reference });
  }

  startTokenDrag(_, ui) {
    const scale = this.pageZoom / 100;
    const $helper = $(ui.helper[0]);
    const newStyles = ['height', 'width', 'font-size']
      .map(stl => `${stl}: ${ parseFloat($helper.css(stl)) * scale }px !important`)
      .join('; ');
    $helper.attr('style', `${ $helper.attr('style') }; ${ newStyles };`);
  }
}

export default {
  bindings: {
    selectedReferenceId: '=',
    isDraggable: '<',
    pageZoom: '<'
  },
  templateUrl: "form-builder/tool-box/tool-box.component.html",
  controller: ToolBoxCtrl
};
